// extracted by mini-css-extract-plugin
module.exports = {"root":"FlexColumn_root___B3SN","wrapper":"FlexColumn_wrapper__VcDJg"};